import { IOperation } from "Types/operation";

import { STATIONS } from "./Stations";

export const OPERATIONS: IOperation[] = [
  {
    name: "create-path",
    text: "تعریف مسیر",
    icon: "route",
    types: STATIONS.map((station) => ({ type: station.type, text: station.text, icon: station.icon })),
  },
  // {
  //   name: "add-station",
  //   text: "ساخت ایستگاه",
  //   icon: "calendar_month",
  //   types: STATIONS.map((station) => ({ type: station.type, text: station.text, icon: station.icon })),
  // },
];
